import React from 'react';
import { Button } from 'carbon-components-react';
import { CaretLeft16, CaretRight16 } from '@carbon/icons-react';

const Pagination: React.FC<Props> = ({
  totalAttachment,
  currentAttachmentIndex,
  handlePrevButtonClick,
  handleNextButtonClick
}) => {
  return (
    <div className="pagination-wrapper">
      <div className="pagination-button-container">
        <Button
          kind="tertiary"
          hasIconOnly
          renderIcon={CaretLeft16}
          iconDescription="Previous"
          tooltipAlignment="start"
          disabled={currentAttachmentIndex <= 1}
          onClick={() => handlePrevButtonClick()}
        />
        <Button
          kind="tertiary"
          hasIconOnly
          renderIcon={CaretRight16}
          iconDescription="Next"
          disabled={currentAttachmentIndex === totalAttachment}
          onClick={() => handleNextButtonClick()}
        />
      </div>
      <div className="current-attachment-indicator">
        {`${currentAttachmentIndex} of ${totalAttachment} item${
          totalAttachment > 1 ? 's' : ''
        }`}
      </div>
    </div>
  );
};

type Props = {
  totalAttachment: number;
  currentAttachmentIndex: number;
  handlePrevButtonClick: Function;
  handleNextButtonClick: Function;
};

export default React.memo(Pagination);
